Backbone = require 'backbone'
Backbone.$ = $
SharedTicketNumberMsgTemplate = require('../../../../ticket_number_msg.html.mustache')
SharedIntlCallUsTemplate = require('../../../../intl_call_us.html.mustache')

class SharedFooterIntlPhoneNumberView extends Backbone.View
  class: 'support'

  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.support'
    @template = SharedIntlCallUsTemplate
    @ticketNumberMsgTemplate = SharedTicketNumberMsgTemplate
    @popupContainer = $("#popup")
    @emailFormModel = @options.emailFormModel
    @shouldRenderPopup = @options.renderPopup

  render: ->
    if @shouldRenderPopup
      @renderPopup()
    else
      @renderPhoneNumber()

    if window.experiments?.callTicketEnabled and window.isLoggedIn
      data = @emailFormModel.getBasicTicketData()
      data.synchronous = true
      createTicket(data, @renderSuccess, @renderError, @$el.find('#ticket-number-msg'), "100px")
      propagateEventBeforeReplacingElements(-> $('#g-spinner').addClass('call-us-popup-spinner'))

  renderSuccess: (response)=>
    ticketNumber = response?.res?.ticket_id
    if ticketNumber?
      @$el.find('#ticket-number-msg').html(toHtml(@ticketNumberMsgTemplate, @getTicketSuccessHash(ticketNumber), @I18nScope))
    else
      @renderError()

  renderError:()=>
    @$el.find('#ticket-number-msg').html("")

  renderPopup: ->
    GIG.Modal.open
      el: @popupContainer
      closeOnBgClick: true
      closeOnEscKey: true
    @renderPhoneNumber()
    @popupContainer.html(@el)

  renderPhoneNumber: ->
    @$el.append toHtml( @template, @toHash(), @I18nScope )

  toHash: ->
    call_us_message : getCallUsMsg()
    shouldRenderPopup: @shouldRenderPopup

  getTicketSuccessHash:(ticketNumber)->
    _.extend {ticket_number: ticketNumber}, window.getOrderInfoForBH(Groupon.Support.currentOrder)

  closeModal: ->
    GIG.Modal.close()
    return false

  events:
    'click .close-modal' : "closeModal"
    'click .b-close' : "closeModal"

module.exports = SharedFooterIntlPhoneNumberView
